import React from 'react'

const ProductReview = () => {
  return (
    <section id="c-sectionProdReview" className="c-sectionWrapper">
    <div className="container">
        <div className="row">
            <div className="col-lg-5 col-md-12">
                <div className="c-sectionHeader">
                    <h5 className="c-heading36Bold">Our Dream</h5>
                    <p className="c-para22Regular">Create monetary system to the world Using AI</p>
                </div>
                
                <div className="c-sectionProdReviewCarouselBox">
                    <div className="owl-carousel owl-theme c-ourProductsCarousel">
                        <div className="item">
                          <img src="./images/logo/our_product_fi_men.png" title="" alt="" />
                          <p>Best your financial asset in a few minutes</p>
                        </div>
                        {/* <!-- <div className="item">
                          <img src="images/our_product_fi_men.png" title="" alt="" />
                          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </div>
                        <div className="item">
                          <img src="images/our_product_fi_men.png" title="" alt="" />
                          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </div> --> */}
                    </div>
                </div>
            </div>
            <div className="col-lg-7 col-md-12">
                <div className="c-sectionHeader">
                    <h5 className="c-heading36Bold">Don't just take our word for it!</h5>
                    <p className="c-para22Regular">Hear from the decision-makers themselves</p>
                </div>
                <div className="c-sectionProdReviewCarouselBox">
                    <div className="owl-carousel owl-theme c-ourReviewCarousel">
                        <div className="item">
                            <div className="c-reviewContentBox">
                                <div className="c-reviewAvatar">
                                    <img style={{borderRadius: "100%", width: "100%", height: "100%"}} src="./images/home/testimonial/finayo.jpg" alt="" title="" />
                                </div>
                                <div className="c-reviewInfo">
                                    <p className="c-reviewInfoReview text-justify">
                                        FINAYO's proficient team identified the key challenges lurking in the domain and harnessed cutting - edge Al - powered technologies to develop FI - MEN . The industry - leading FI-MEN solution boasts India's first Asset assessment Rule Engine for OEMs and Lender Credit policy-based recommendation Engine for banks and NBFCs to furnish competitive loan offers to prospective EV buyers conveniently and swiftly
                                    </p>
                                    <h6 className="c-reviewInfoName">Brajendra,<br/>Founder & CEO &nbsp; | &nbsp;Finayo</h6>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="c-reviewContentBox">
                                <div className="c-reviewAvatar">
                                    <img style={{borderRadius: "100%", width: "100%", height: "100%"}} src="./images/home/testimonial/IA.jpg" alt="" title="" />
                                </div>
                                <div className="c-reviewInfo">
                                    <p className="c-reviewInfoReview text-justify">
                                        FINAYO has developed a tech solution FI-MEN that will bridge the gap between retailers and financial institutions by drastically reducing the time taken for approval of the loan. The facility to provide loan approval 24x7 will be a game-changer in the industry.
                                    </p>
                                    <h6 className="c-reviewInfoName">Munish Bhatia,<br/>Co-founder & Investor &nbsp; | &nbsp;India Accelerator(IA)</h6>
                                </div>
                            </div>
                        </div>
                        {/* <!-- <div className="item">
                            <div className="c-reviewContentBox">
                                <div className="c-reviewAvatar">
                                    <img src="images/avatar.png" alt="" title="" />
                                </div>
                                <div className="c-reviewInfo">
                                    <p className="c-reviewInfoReview">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text everLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever
                                    </p>
                                    <h6 className="c-reviewInfoName">Brajendra,<br>CEO &nbsp; Founder - Finayo</h6>
                                </div>
                            </div>
                        </div> -->*/}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default ProductReview